(function () {
  var root = document.querySelector('[data-tcb-buying-guides]');
  if (!root) return;

  var machineUrl = root.getAttribute('data-machine-url') || '/pages/machine-buying-guides';
  var allGuidesUrl = root.getAttribute('data-all-guides-url') || '/pages/all-buying-guides';
  var legacyHashes = {
    'machine-guides': machineUrl,
    'tcb-bg-machine-guides': machineUrl,
    'tcb-bg-all-guides': allGuidesUrl
  };
  var hashKey = (window.location.hash || '').replace(/^#/, '');
  if (legacyHashes[hashKey]) {
    window.location.replace(legacyHashes[hashKey]);
    return;
  }

  var filterBtns = root.querySelectorAll('[data-bg-filter]');
  var cards = root.querySelectorAll('[data-bg-guide]');
  var emptyEl = root.querySelector('[data-bg-empty]');
  var searchInput = root.querySelector('[data-bg-search]');
  var searchForm = root.querySelector('[data-bg-search-form]');
  var activeFilter = 'all';

  function norm(value) {
    return (value || '').toLowerCase().trim();
  }

  function applyFilters() {
    var query = searchInput ? norm(searchInput.value) : '';
    var visible = 0;

    cards.forEach(function (card) {
      var categories = norm(card.getAttribute('data-categories')).split(/\s+/).filter(Boolean);
      var title = norm(card.getAttribute('data-title'));
      var excerpt = norm(card.getAttribute('data-excerpt'));
      var categoryMatch = activeFilter === 'all' || categories.indexOf(activeFilter) !== -1;
      var searchMatch = !query || title.indexOf(query) !== -1 || excerpt.indexOf(query) !== -1;
      var show = categoryMatch && searchMatch;

      card.hidden = !show;
      if (show) visible += 1;
    });

    if (emptyEl) emptyEl.hidden = visible > 0;
  }

  function setActiveFilter(nextFilter, sourceBtn) {
    activeFilter = nextFilter || 'all';

    filterBtns.forEach(function (btn) {
      var btnFilter = btn.getAttribute('data-bg-filter') || 'all';
      var isActive = btnFilter === activeFilter;
      btn.classList.toggle('is-active', isActive);
      if (btn.classList.contains('tcb-rh-cat--filter')) {
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      } else if (btn.classList.contains('tcb-bg-filter-bar__pill')) {
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    });

    applyFilters();
  }

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setActiveFilter(btn.getAttribute('data-bg-filter'), btn);

      var target = root.querySelector('#tcb-bg-all-guides');
      if (target && btn.classList.contains('tcb-rh-cat--filter')) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();

      var query = searchInput && searchInput.value.trim();
      if (query && emptyEl && emptyEl.hidden === false) {
        window.location.href =
          '/search?q=' + encodeURIComponent(query) + '&type=article';
      }
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  // ponytail: hash-only deep links (#floor-machines); query ?filter= not used on this hub yet
  var hashFilter = (window.location.hash || '').replace(/^#/, '');
  if (hashFilter && root.querySelector('[data-bg-filter="' + hashFilter + '"]')) {
    setActiveFilter(hashFilter);
    var allGuides = root.querySelector('#tcb-bg-all-guides');
    if (allGuides) {
      requestAnimationFrame(function () {
        allGuides.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  } else {
    applyFilters();
  }
})();
